import React from 'react';
import { FiAward } from 'react-icons/fi';

const certifications = [
    { name: 'LPT Master', logo: '/cert-logos/lpt.png' },
    { name: 'CPENT', logo: '/cert-logos/cpent.png' },
    { name: 'PNPT', logo: '/cert-logos/pnpt.png' },
    { name: 'Pentest+', logo: '/cert-logos/pentest+.png' },
    { name: 'CEH', logo: '/cert-logos/ceh.png' },
    { name: 'CRTO', logo: '/cert-logos/crto.png' },
    { name: 'and many others', logo: '/cert-logos/generic.png' },
];

const achievements = [
    { title: 'ASEAN Cyber Shield 2023', result: '🥈 2nd Place' },
    { title: 'ASCIS Vietnam 2022', result: '🏅 Finalist' },
    { title: 'BPJS HEALTHKATHON 2023', result: '🥇 1st Place' },
    { title: 'HackTheon Sejong Korea 2024', result: '🏅 Finalist' },
    { title: 'CyberSec Hackathon 2022', result: '🥇 1st Place' },
    { title: 'uConnect CTF 2023', result: '🥇 1st Place' },
    { title: 'TechComfest 2024', result: '🥇 1st Place' },
    { title: 'Cyber SEA Game 2024', result: '🥉 3rd Place' },
    { title: 'and many others', result: '' },
];

const TrainerCertifications = () => {
    return (
        <section className="bg-[#1a1a1a] text-white px-6 md:px-16 py-20">
            {/* Certifications */}
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold">
                    Team’s <span className="text-red-500">Certifications</span>
                </h2>
                <p className="text-gray-400 mt-2 max-w-2xl mx-auto">
                    Our team are globally recognized cybersecurity professionals who hold some of the industry’s most advanced certifications, reflecting their deep knowledge and field-tested expertise in offensive and defensive security.
                </p>
            </div>

            <div className="flex flex-wrap justify-center gap-6 mb-16">
                {certifications.map((cert, idx) => (
                    <div
                        key={idx}
                        className="bg-[#2a2a2a] border border-red-500 rounded-xl px-6 py-4 flex flex-col items-center shadow-md hover:scale-105 transition w-40"
                        data-aos="zoom-in"
                        data-aos-delay={idx * 100}
                    >
                        <img
                            src={cert.logo}
                            alt={`${cert.name} logo`}
                            className="h-20 mb-3 object-contain"
                        />
                        <p className="text-sm text-white text-center font-semibold">{cert.name}</p>
                    </div>
                ))}
            </div>

            {/* Achievements */}
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold">
                    Team’s <span className="text-red-500">Achievements</span>
                </h2>
                <p className="text-gray-400 mt-2 max-w-2xl mx-auto">
                    Our team have consistently demonstrated elite-level performance in international cybersecurity competitions — winning CTFs, securing podium finishes, and showcasing their ability to solve complex real-world challenges under pressure.
                </p>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
                {achievements.map((ach, idx) => (
                    <div
                        key={idx}
                        className="bg-gradient-to-br from-[#2d2d2d] to-[#1f1f1f] border border-red-500 rounded-xl px-6 py-6 shadow-lg hover:shadow-xl transition relative overflow-hidden"
                        data-aos="fade-up"
                        data-aos-delay={idx * 100}
                    >
                        <div className="flex items-center gap-3 mb-2">
                            <FiAward className="text-red-500 text-xl" />
                            <h3 className="font-bold text-lg">{ach.title}</h3>
                        </div>
                        {ach.result && (
                            <div className="text-red-400 font-semibold text-md mt-1">{ach.result}</div>
                        )}
                        <div className="absolute top-0 right-0 opacity-10 text-7xl pointer-events-none">
                            🏆
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default TrainerCertifications;
